import { t } from 'i18next';

import ModalViewJSON from '../../../../../../../../components/ModalViewJSON';
import { VisitHistory } from '../../../../../../../../types/apiResponse/visitHistory';

type Props = {
  showModal: boolean;
  closeModal: () => void;
  history: VisitHistory | null;
};

const ModalVisitHistoryDetail = ({ showModal, closeModal, history }: Props) => {
  if (!history) {
    return null;
  }

  return (
    <ModalViewJSON
      showModal={showModal}
      closeModal={closeModal}
      data={JSON.stringify(history, null, 2)}
      title={`${t('viewDetails')} - ${t('visitHistory')}`}
    />

  );
};

export default ModalVisitHistoryDetail;
